export default "__VITE_ASSET__BYT4MrHW__"